import { Heart, Calendar, FileText, Cat, Dog, Bird, Fish, Activity } from 'lucide-react'

const categories = [
  { id: 'all', name: 'Todas', icon: Heart },
  { id: 'mascotas', name: 'Mascotas', icon: Heart },
  { id: 'citas', name: 'Citas', icon: Calendar },
  { id: 'fichas', name: 'Fichas', icon: FileText },
]

export default function CategoryFilters({ 
  selectedCategory = 'all', 
  onCategoryChange,
  categories: customCategories = null 
}) {
  const categoriesToShow = customCategories || categories

  return (
    <div className="py-3 overflow-x-auto scrollbar-hide -mx-4 px-4">
      <div className="flex space-x-3 min-w-max">
        {categoriesToShow.map((category) => {
          const Icon = category.icon
          const isSelected = selectedCategory === category.id
          
          return (
            <button
              key={category.id}
              onClick={() => onCategoryChange(category.id)}
              className={`
                flex items-center space-x-2 px-5 py-2.5 rounded-full transition-all duration-200 whitespace-nowrap
                ${isSelected
                  ? 'bg-gradient-to-r from-pastel-teal to-primary-400 text-white shadow-soft font-medium'
                  : 'bg-white dark:bg-slate-600 text-pastel-ink dark:text-slate-300 hover:bg-pastel-cream dark:hover:bg-slate-500 border border-pastel-pink dark:border-slate-500'
                }
              `}
            >
              <Icon className={`w-5 h-5 ${isSelected ? 'text-white' : ''}`} />
              <span className="font-medium text-sm">{category.name}</span>
            </button>
          )
        })}
      </div>
    </div>
  )
}
